// 字符串截图
export function plusXing(str, frontLen, endLen) {
    // 截取字符串 保留前后几位 中间用*代替
    // frontLen 前面保留位数 endLen后面保留位数
    const len = str.length - frontLen - endLen;
    let xing = '';
    for (let i = 0; i < len; i++) {
        xing += '*';
    }
    return str.substr(0, frontLen) + xing + str.substr(str.length - endLen);
}

// 时分秒
export function secondToDate(than, result) {
    const h = Math.floor(result / 3600) < 10 ? `0${Math.floor(result / 3600)}` : Math.floor(result / 3600);
    let m = Math.floor(((result / 60) % 60)) < 10 ? `0${Math.floor(((result / 60) % 60))}` : Math.floor(((result / 60) % 60));
    const second = result == null ? 0 : window.parseInt(result);
    const sBool = window.parseInt(second % 60);
    if (sBool >= 30) {
        m = Number(m) + 1;
    }
    // const s = Math.floor((result % 60)) < 10 ? `0${Math.floor((result % 60))}` : Math.floor((result % 60));
    const testH = Number(h) ? `${Number(h)}${than.$t('lang.hour')}` : '';
    const testM = Number(m) ? `${Number(m)}${than.$t('lang.minute')}` : '';
    return `${testH}${testM}`;
}

export function imgUrlType(type) {
    // 老框架的 home-default-image
    const list = [
        'images/default-cover/default_class.jpg',
        'images/default-cover/default_live.jpg',
        'images/default-cover/default_exam.jpg',
        'images/default-cover/default_survey.jpg', 'mooc',
        'unknow',
        'images/default-cover/default_live.jpg',
        'unknow',
        'images/default-cover/default_course.jpg',
        'images/default-cover/default_spceial.jpg'
    ];
    return list[Number(type) - 1];
}

export function homeDataUrl(type) {
    // 老框架的 home-data-url
    const list = [
        '/#/train-new/class-detail/',
        '/#/activity/gensee/detail/',
        '/#/exam/exam/answer-paper/',
        '/#/exam/research-activity/index/',
        '#',
        '#',
        '/#/live/detail/',
        '#',
        '/#/study/course/detail/',
        '/#/study/subject/detail/'
    ];
    return list[Number(type) - 1];
}
